import Amplify from "aws-amplify";
import request from "superagent";
import APP_ENV from "../Environment";

Amplify.configure({
    Auth: {
        region: 'ap-northeast-1', // REQUIRED - Amazon Cognito Region
        userPoolId: APP_ENV.USERPOOLID, //OPTIONAL - Amazon Cognito User Pool ID
        userPoolWebClientId: APP_ENV.USERPOOLWEBCLIENTID, //OPTIONAL - Amazon Cognito Web Client ID
        authenticationFlowType: 'USER_PASSWORD_AUTH',
    }
});

const getAffiliateAgreements = (idToken) => {
    return new Promise((resolve, reject) => {
        request
            .get(APP_ENV.BFF + '/affiliates/withoutkey/agreements')
            .set('Accept', 'application/json')
            .set('x-api-key', process.env.REACT_APP_XAPI_KEY)
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${idToken}`)
            .end((err, res) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve({res})
            });
    });

};

const postAffiliateAgreements = (idToken, process_name) => {
    return new Promise((resolve, reject) => {
        request
            .post(APP_ENV.BFF + '/affiliates/withoutkey/agreements')
            .set('Accept', 'application/json')
            .set('x-api-key', process.env.REACT_APP_XAPI_KEY)
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${idToken}`)
            .send({
                process: process_name,
            })
            .end((err, res) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve({res})
            });
    });

};

const putAffiliateAgreements = (idToken) => {
    return new Promise((resolve, reject) => {
        request
            .put(APP_ENV.BFF + '/affiliates/withoutkey/agreements')
            .set('Accept', 'application/json')
            .set('x-api-key', process.env.REACT_APP_XAPI_KEY)
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${idToken}`)
            .end((err, res) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve({res})
            });
    });

};

export const requestAffiliateAgreements = async (method, process = null) => {
    try {
        const data = await Amplify.Auth.currentSession();
        const idToken = data.idToken.jwtToken;
        let affiliate_res = null;
        switch(method) {
            case 'get':
                affiliate_res =  await getAffiliateAgreements(idToken);
                break;
            case 'post':
                affiliate_res =  await postAffiliateAgreements(idToken, process);
                break;
            case 'put':
                affiliate_res =  await putAffiliateAgreements(idToken);
                break;
            default:
                break;
        }
        return affiliate_res;

    } catch (e) {
        throw e;
    }
};

export default requestAffiliateAgreements;
